import * as React from 'react';
export const IcVideoCalls = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.91 10.51a1.11 1.11 0 00-.12-.27.249.249 0 010-.07c-.07-.099-.15-.19-.24-.27l-.06-.05a1.885 1.885 0 00-.23-.16h-.09a1.859 1.859 0 00-.31-.1h-.3l-.29.05h-.14a1.41 1.41 0 00-.42.22L17 11.75V11a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h9a3 3 0 003-3v-.75l2.6 1.95c.127.097.269.17.42.22h.14l.29.05c.1.01.2.01.3 0 .106-.024.21-.058.31-.1l.09-.05c.08-.047.157-.101.23-.16h.06c.09-.08.17-.171.24-.27a.249.249 0 010-.07 1.11 1.11 0 00.12-.27v-.1c.096-.135.164-.288.2-.45v-6a1.23 1.23 0 00-.06-.39l-.03-.1zm-1.83-6L18 6.12V5.5A2.451 2.451 0 0015.6 3H8.4A2.45 2.45 0 006 5.5V6h8a5 5 0 014.23 2.33l.17-.13a3.45 3.45 0 013.6-.35V5.5a1.2 1.2 0 00-1.92-1v.01z'
      fill='currentColor'
    />
  </svg>
);
